module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/2b2t.1c7c5b3c.webp";